import { render, staticRenderFns } from "./CoachJose.vue?vue&type=template&id=36c1447c&scoped=true&"
import script from "./CoachJose.vue?vue&type=script&lang=js&"
export * from "./CoachJose.vue?vue&type=script&lang=js&"
import style0 from "./CoachJose.vue?vue&type=style&index=0&id=36c1447c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c1447c",
  null
  
)

export default component.exports